import * as React from 'react';

const SvgIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
    <path d="M164-164v-268h52v179.23L707.23-744H528v-52h268v268h-52v-179.23L252.77-216H432v52z"></path>
  </svg>
);

export default SvgIcon;
